import l from "./ghl-ui.es1589.js";
import p from "./ghl-ui.es1590.js";
import m from "./ghl-ui.es1586.js";
import h from "./ghl-ui.es1587.js";
import M from "./ghl-ui.es1588.js";
import u from "./ghl-ui.es1591.js";
import { mapValue as i, parseNDigits as v, parseNumericPattern as w } from "./ghl-ui.es1671.js";
import { Parser as b } from "./ghl-ui.es1670.js";
import { numericPatterns as x } from "./ghl-ui.es1672.js";
var I = /* @__PURE__ */ function(c) {
  h(n, c);
  var s = M(n);
  function n() {
    var o;
    l(this, n);
    for (var r = arguments.length, e = new Array(r), t = 0; t < r; t++)
      e[t] = arguments[t];
    return o = s.call.apply(s, [this].concat(e)), u(m(o), "incompatibleTokens", ["Y", "R", "q", "Q", "L", "w", "I", "D", "i", "e", "c", "t", "T"]), u(m(o), "priority", 110), o;
  }
  return p(n, [{
    key: "parse",
    value: function(r, e, t) {
      var a = function(f) {
        return f - 1;
      };
      switch (e) {
        case "M":
          return i(w(x.month, r), a);
        case "MM":
          return i(v(2, r), a);
        case "Mo":
          return i(t.ordinalNumber(r, {
            unit: "month"
          }), a);
        case "MMM":
          return t.month(r, {
            width: "abbreviated",
            context: "formatting"
          }) || t.month(r, {
            width: "narrow",
            context: "formatting"
          });
        case "MMMMM":
          return t.month(r, {
            width: "narrow",
            context: "formatting"
          });
        case "MMMM":
        default:
          return t.month(r, {
            width: "wide",
            context: "formatting"
          }) || t.month(r, {
            width: "abbreviated",
            context: "formatting"
          }) || t.month(r, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "validate",
    value: function(r, e) {
      return e >= 0 && e <= 11;
    }
  }, {
    key: "set",
    value: function(r, e, t) {
      return r.setUTCMonth(t, 1), r.setUTCHours(0, 0, 0, 0), r;
    }
  }]), n;
}(b);
export {
  I as MonthParser
};
